import { BrandInformation } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { convertFileToBase64 } from '../../../../../../../utils/convertFileToBase64';
import { convertUrlObjectToFile } from '../../../../../../../utils/convertUrlObjectToFile';
import { ImageFile } from '../types/ImageFile';

export const useBranding = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [brandLogoImageFile, setBrandLogoImageFile] = useState<ImageFile | undefined>();

  const resetBrandLogo = async (brandInformation: BrandInformation): Promise<void> => {
    !loading && setLoading(true);
    if (!brandInformation?.brandLogoUrl) {
      setLoading(false);
      return;
    }
    try {
      const file = await convertUrlObjectToFile(brandInformation.brandLogoUrl);
      const result = await convertFileToBase64(file);
      setBrandLogoImageFile({
        base64: result,
        file,
        name: file.name,
        size: file.size,
        mimeType: file.type,
      });
    } catch (e) {}
    setLoading(false);
  };

  return { loading, brandLogoImageFile, setBrandLogoImageFile, resetBrandLogo };
};
